const deleteFeatureMutation = `
  mutation DeleteMarketplaceFeature($id: ID!) {
    deleteMarketplace_feature(input: { id: $id }) {
      marketplace_feature {
        objectId
      }
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default deleteFeatureMutation;
